export default "__VITE_ASSET__l4ke50F7__"